module.exports = __webpack_public_path__ + "img/vuejs.f246888d.png";